module.exports = __webpack_public_path__ + "img/avatar3.af06fd8d.png";